import { useEffect, useState } from 'react';
import { Box, Heading, Text, VStack, Spinner, Center } from '@chakra-ui/react';
import axios from 'axios';

export default function AiCronosNewsFeed() {
  const [news, setNews] = useState<{ text: string; timestamp?: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get('https://reckless-command-center.herokuapp.com/api/ai-news', {
          headers: {
            Accept: 'application/json',
          },
        });

        if (res.data && typeof res.data.text === 'string') {
          setNews(res.data);
          console.log('✅ News received:', res.data);
        } else {
          throw new Error('Invalid response format');
        }
      } catch (err: any) {
        console.error('❌ Failed to fetch AI news:', err);
        setError('Could not load the news. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []); // <-- only runs once on mount

  if (loading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" color="purple.500" />
      </Center>
    );
  }

  if (error) {
    return (
      <Center minH="100vh">
        <Text color="red.500">{error}</Text>
      </Center>
    );
  }

  return (
    <Center py={10} bg="gray.100" minH="100vh">
      <Box
        maxW="3xl"
        bg="white"
        boxShadow="2xl"
        borderRadius="lg"
        p={8}
        border="4px solid black"
        fontFamily="'Courier New', Courier, monospace"
        backgroundImage="url('/newspaper-texture.png')"
        backgroundSize="cover"
        backgroundRepeat="repeat"
      >
        <Heading
          fontSize="4xl"
          mb={4}
          color="black"
          textAlign="center"
          borderBottom="2px solid black"
        >
          🗞️ The Daily CROnomics
        </Heading>
        <Text fontSize="sm" color="black" textAlign="center" mb={6}>
          {news?.timestamp
            ? new Date(news.timestamp).toLocaleString()
            : new Date().toLocaleDateString()}
        </Text>
        <VStack align="start" spacing={4}>
  <Text fontSize="lg" whiteSpace="pre-wrap" color="black">
    
    {news?.text}
   
  </Text>
</VStack>
        <Text mt={8} fontSize="sm" color="gray.500" textAlign="center">
          🤖 This news is AI-generated daily using the OpenAI API
        </Text>
      </Box>
    </Center>
  );
}
